<template>
	<v-container fill-height>
		<!--   TODO:Exibir carregando novamente -->
		<v-row justify="center" align="center">
			<v-icon class="mt-3 mb-3" size="100" color="#b80f0f">
				mdi-alert-circle-outline
			</v-icon>
			<v-col cols="12" class="mt-3 mb-3 text-center">
				<h2 class="mb-0 text-center">
					Alguns dos nossos serviços estão atualmente indisponíveis ou houve um problema com sua conexão.
					<br/>
					Verifique sua conexão e caso o problema persista, tente novamente mais tarde!
				</h2>
			</v-col>
			<v-col cols="12" class="mt-3 mb-3 text-center">
				<v-btn color="primary" outlined large depressed @click="atualizar()" :loading="carregando">
					Atualizar
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { verificarDisponibilidadeApiEfm } from "@/services/VerificarDisponibilidadeService.js";
	import * as dadosFixosService from "@/services/DadosFixosService.js";

	export default {
		name: "ErroInterno",
		data(){
			return {
				carregando: false,
				rotaAnterior: null,
			};
		},
		beforeRouteEnter(to, from, next){
			next((vm) => {
				vm.rotaAnterior = from.fullPath;
			});
		},
		created(){
			this.atualizar();
		},
		methods: {
			atualizar(){
				this.carregando = true;
				verificarDisponibilidadeApiEfm()
					.then(() => {
						dadosFixosService.carregarDadosFixosUsuarioLogadoAsync(this.$store)
							.then(() => {
								dadosFixosService.carregarDadosFixosUsuarioNaoLogadoAsync(this.$store)
									.then(() => {
										if(this.rotaAnterior && !this.rotaAnterior.includes("erro-interno")){
											console.warn("Redirecionando para a rota anterior");
											this.$router.replace(this.rotaAnterior).catch(() => {});
										}
										else{
											console.warn("Redirecionando para a dashboard");
											this.$router.replace("/").catch(() => {});
										}
									})
									.catch((e) => {
										console.error("Erro ao carregar dados fixos");
										throw e;
									});
							})
							.catch((e) => {
								console.error("Erro ao carregar dados do usuário");
								throw e;
							});
					})
					.catch((e) => {
						console.error(e);
						console.error("Erro ao tentar se comunicar com a api.");
					})
					.finally(() => {
						this.carregando = false;
					});
			},
		},
	};
</script>
